export const config = {
  title: 'Omi Home Improvement',
  meta: {
    description:
      'Omi Home Improvement offers expert home renovation and remodeling services in Bridgeport, CT. From kitchen and bathroom remodels to roofing and siding, we transform your home with quality craftsmanship.',
    keywords: [
      'Home Improvement Bridgeport CT',
      'Kitchen Remodeling',
      'Bathroom Renovation',
      'Roofing Services',
      'Siding Installation',
      'Omi Home Improvement',
    ],
    author: 'Omi Home Improvement',
    canonicalUrl: 'https://omihomeimprovement.com/',
  },
  sections: {
    header: {
      businessName: 'Omi Home Improvement',
    },
    sectionB: {
      heroTitle: 'Omi Home Improvement',
      heroSubtitle: 'Transforming Homes in Bridgeport, CT with Quality Craftsmanship',
      learnAboutText: 'Discover Our Services',
      phoneNumber: '3475236117',
      phoneLabel: '(347) 523-6117',
      heroBackgroundImage:
        'https://media.istockphoto.com/id/2171361583/photo/kitchen-fitting-team-installing.jpg?s=612x612&w=0&k=20&c=wdLy7lw_S4QwW8Tfy_EmzGGYuex5AfW5aYJ2wvvqWiA=',
      cardData: [
        {
          title: 'Experienced Professionals',
          description:
            'Our team brings years of experience to every project, ensuring top-notch results.',
        },
        {
          title: 'Customized Solutions',
          description:
            'We tailor our services to meet your specific home improvement needs.',
        },
        {
          title: 'Quality Materials',
          description:
            'We use only high-quality materials to ensure durability and satisfaction.',
        },
      ],
      description:
        'At Omi Home Improvement, we specialize in comprehensive home renovation services, including kitchen and bathroom remodels, roofing, siding, and more. Serving Bridgeport, CT, we are committed to enhancing your home\'s beauty and functionality.',
    },
    sectionC: {
      servicesTitle: 'Our Services',
      servicesDescription:
        'Explore our wide range of home improvement services designed to transform your living space.',
      cards: [
        {
          title: 'Kitchen Remodeling',
          description:
            'Upgrade your kitchen with modern designs and functional layouts.',
          imageSrc: 'https://media.istockphoto.com/id/1128522986/photo/custom-kitchen-cabinets-of-installation-base-of-kitchen-cabinets.jpg?s=612x612&w=0&k=20&c=CjM_zuzFyXtrB-X_Lrb0Ahwd0pm0Zmzh_S2Y84Jv-PA=',
          imageAlt: 'Kitchen Remodeling',
        },
        {
          title: 'Bathroom Renovation',
          description:
            'Transform your bathroom into a relaxing and stylish space.',
          imageSrc: 'https://media.istockphoto.com/id/1146120013/photo/young-man-fixing-a-leak-under-the-bathroom-sink.jpg?s=612x612&w=0&k=20&c=_5OmB9-zzKEZLCKRQQpVgI353G2SnhjLhpikaMOUCZ0=',
          imageAlt: 'Bathroom Renovation',
        },
        {
          title: 'Roofing Services',
          description:
            'Protect your home with our reliable roofing installation and repair services.',
          imageSrc: 'https://media.istockphoto.com/id/2160402560/photo/construction-worker-is-inspecting-roof-tile-cracked.jpg?s=612x612&w=0&k=20&c=xlJhNN05zKhnGXrZRYiStTPKwri2vdvY7YtSIgUanXw=',
          imageAlt: 'Roofing Services',
        },
      ],
      otherServicesTitle: 'Additional Services',
      otherServicesList: [
        'Siding Installation',
        'Window Replacement',
        'Deck Construction',
        'Flooring Installation',
        'Basement Finishing',
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src: 'https://omihomeimprovement.com/wp-content/uploads/2025/04/unnamed-37.jpg',
      },
      aboutText: [
        'Omi Home Improvement is a trusted home renovation company based in Bridgeport, CT. Our mission is to provide high-quality remodeling services that exceed our clients\' expectations.',
        'With a focus on craftsmanship and customer satisfaction, we handle projects of all sizes, delivering results that enhance the comfort and value of your home.',
      ],
    },
    sectionE: {
      profileImage: 'https://omihomeimprovement.com/wp-content/uploads/2025/04/unnamed-37.jpg',
      profileAlt: 'Omi Home Improvement Logo',
      businessName: 'Omi Home Improvement',
      contact: {
        phone: '3475236117',
        phoneLabel: '(347) 523-6117',
        email: 'omiconstruction14@gmail.com',
        website: 'https://omihomeimprovement.com/',
        address: 'Bridgeport, CT 06606',
      },
      socialMedia: {
        facebook: null,
        twitter: null,
        instagram: null,
        linkedin: null,
        youtube: null,
      },
    },
    sectionF: {
      address: 'Bridgeport, CT 06606',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3038.123456789012!2d-73.2080000!3d41.1910000!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89e81d1234567890%3A0xabcdef1234567890!2sBridgeport%2C%20CT%2006606!5e0!3m2!1sen!2sus!4v1614123456789!5m2!1sen!2sus',
    },
  },
};

export default config;
